import React, { Component } from 'react';
import { Grid, Paper as Card } from '@material-ui/core';
import { Brush, LaptopMac, Palette, People, Settings } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import AccessCode from './AccessCode/AccessCode';
import ProfileDetails from './ProfileDetails';
import UpdateContest from './UpdateContest';
import CurrentContest from './CurrentContest';
import TeamMembers from './TeamMembers';
import NewContestForm from './NewContestForm';
import Seo from '../Seo/Seo';

const styles = theme => ({
    root: {
        flexGrow: 1,
        minHeight: '100vh',
        background: 'linear-gradient(160deg, rgba(63, 66, 74, 0.95) 0%, rgba(32, 34, 40, 0.98) 100%)',
        padding: theme.spacing(4, 4, 10),
        marginTop: theme.spacing(8),
        borderRadius: 28,
        boxShadow: '0 18px 40px rgba(7, 9, 15, 0.45)',
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(3),
            padding: theme.spacing(2, 1.25, 4),
            borderRadius: 16,
        },
    },
    card: {
        textAlign: 'center',
        background: 'rgba(40, 46, 60, 0.75)',
        color: 'white',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 18,
        padding: theme.spacing(3),
        boxShadow: '0 14px 30px rgba(9, 11, 18, 0.35)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        backdropFilter: 'blur(14px)',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
            borderRadius: 14,
        },
    },
    icon: {
        width: 35,
        height: 35,
        marginLeft: 10,
        marginBottom: -8,
        opacity: 0.85,
        [theme.breakpoints.down('sm')]: {
            width: 28,
            height: 28,
            marginLeft: 6,
            marginBottom: -5,
        },
    },
    h1: {
        fontSize: 34,
        letterSpacing: 0.6,
        margin: 0,
        textTransform: 'none',
        fontWeight: 600,
        [theme.breakpoints.down('sm')]: {
            fontSize: 30,
            textAlign: 'center',
            width: '100%',
        },
    },
    headerRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(3),
        flexWrap: 'wrap',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
            marginBottom: theme.spacing(2),
        },
    },
    newContestButton: {
        marginLeft: 'auto',
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
        },
    },
    sectionHeader: {
        textTransform: 'none',
        letterSpacing: 0.4,
        fontWeight: 600,
        marginBottom: theme.spacing(1.5),
        [theme.breakpoints.down('sm')]: {
            textAlign: 'left',
            marginBottom: theme.spacing(1),
        },
    },
    colorDiv: {
        width: 55,
        height: 55,
        border: 0,
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 10,
        marginRight: 10,
        borderRadius: 12,
        position: 'relative',
        overflow: 'hidden',
        backgroundClip: 'padding-box',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        boxShadow: '0 12px 22px rgba(0, 0, 0, 0.4)',
        cursor: 'pointer',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
        '&:hover': {
            transform: 'translateY(-3px) scale(1.02)',
            boxShadow: '0 18px 30px rgba(0, 0, 0, 0.5)',
        },
        '&:focus-visible': {
            outline: 'none',
            boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.4), 0 16px 28px rgba(0, 0, 0, 0.55)',
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 0) 55%)',
            opacity: 0.6,
            pointerEvents: 'none',
        },
    },
    colorDivSelected: {
        transform: 'translateY(-2px) scale(1.08)',
        borderColor: 'rgba(255, 255, 255, 0.75)',
        boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.25), 0 20px 32px rgba(0, 0, 0, 0.6)',
        '&::after': {
            opacity: 0.85,
        },
    },
    questionColorHolder: {
        width: '100%',
        maxWidth: 260,
        height: 85,
        margin: theme.spacing(1, 'auto'),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 16,
        padding: 6,
        background: 'rgba(0, 0, 0, 0.25)',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        cursor: 'pointer',
        boxShadow: '0 12px 22px rgba(0, 0, 0, 0.35)',
        transition: 'transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
            transform: 'translateY(-3px)',
            borderColor: 'rgba(255, 255, 255, 0.4)',
            boxShadow: '0 18px 28px rgba(0, 0, 0, 0.45)',
        },
        '&:focus-visible': {
            outline: 'none',
            boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.35), 0 18px 28px rgba(0, 0, 0, 0.45)',
        },
        [theme.breakpoints.down('sm')]: {
            maxWidth: 232,
        },
    },
    questionColorHolderSelected: {
        borderColor: 'rgba(255, 255, 255, 0.75)',
        boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.25), 0 20px 32px rgba(0, 0, 0, 0.55)',
    },
    questionColorHolderColorBlock: {
        width: 55,
        height: 55,
        border: 0,
        marginTop: 10,
        marginBottom: 10,
        borderRadius: 12,
        boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.25), 0 8px 14px rgba(0, 0, 0, 0.35)',
        backgroundImage: 'linear-gradient(150deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0) 60%)',
    },
    sectionSpacer: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        height: 2,
        background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.12), transparent)',
    },
});

class Profile extends Component {

    componentDidMount() {
        this.getUserDetails();
    }

    getUserDetails() {
        this.props.dispatch({
            type: 'FETCH_TEAM_USERS'
        })
    }

    handleColorChange = (color) => {
        let colorObject = {
            color: color
        }
        this.props.dispatch({
            type: 'UPDATE_USER_COLOR',
            payload: colorObject
        })
    }

    handleQuestionColorChange = (color) => {
        let colorObject = {
            color: color
        }
        this.props.dispatch({
            type: 'UPDATE_USER_FAB_COLOR_PREFERENCE',
            payload: colorObject
        })
    }

    handleSelectOnKey = (event, action) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            action();
        }
    }

    render() {

        const { classes } = this.props
        const selectedColor = this.props.user.color;
        const selectedFabColor = this.props.user.fab_color;
        const colorOptions = [
            { value: '#ffb969', label: 'Warm apricot' },
            { value: '#55d685', label: 'Fresh mint' },
            { value: '#0fefff', label: 'Electric aqua' },
            { value: '#cb70ff', label: 'Violet glow' },
            { value: '#ff99f6', label: 'Cotton candy' },
            { value: '#ff6181', label: 'Sunset coral' },
        ];

        return (
            <div className={classes.root}>
                <Seo
                    title="Team Settings | Trivia Weekend"
                    description="Update team preferences, colors, contests, and members in Trivia Weekend settings."
                    canonicalPath="/#/profile"
                    ogType="website"
                />
                <div className={classes.headerRow}>
                    <h1 className={classes.h1}>Settings<Settings className={classes.icon} /></h1>
                    {(this.props.user.clearance_id > 1) &&
                        <div className={classes.newContestButton}><NewContestForm /></div>}
                </div>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <h2 className={classes.sectionHeader}>Background<Palette className={classes.icon} /></h2>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <h2 className={classes.sectionHeader}>Questions<Brush className={classes.icon} /></h2>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Card className={classes.card}>
                            {colorOptions.map((option) => {
                                const isSelected = selectedColor === option.value;
                                return (
                                    <button
                                        key={option.value}
                                        type="button"
                                        aria-label={`Set background color to ${option.label}`}
                                        aria-pressed={isSelected}
                                        className={`${classes.colorDiv} ${isSelected ? classes.colorDivSelected : ''}`}
                                        style={{ backgroundColor: option.value, height: isSelected ? 65 : 55, width: isSelected ? 65 : 55 }}
                                        onClick={() => this.handleColorChange(option.value)}
                                    />
                                );
                            })}
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Card className={classes.card}>
                            <div
                                role="button"
                                tabIndex={0}
                                aria-label="Set question colors to traditional palette"
                                className={`${classes.questionColorHolder} ${selectedFabColor === "traditional" ? classes.questionColorHolderSelected : ''}`}
                                onClick={() => this.handleQuestionColorChange('traditional')}
                                onKeyDown={(event) => this.handleSelectOnKey(event, () => this.handleQuestionColorChange('traditional'))}
                            >
                                <div className={classes.questionColorHolderColorBlock} style={{ backgroundColor: "#f56c64" }}></div>
                                <div className={classes.questionColorHolderColorBlock} style={{ backgroundColor: "#f7f78d" }}></div>
                                <div className={classes.questionColorHolderColorBlock} style={{ backgroundColor: "#55d685" }}></div>
                            </div>
                            <div
                                role="button"
                                tabIndex={0}
                                aria-label="Set question colors to bright palette"
                                className={`${classes.questionColorHolder} ${selectedFabColor === "bright" ? classes.questionColorHolderSelected : ''}`}
                                onClick={() => this.handleQuestionColorChange('bright')}
                                onKeyDown={(event) => this.handleSelectOnKey(event, () => this.handleQuestionColorChange('bright'))}
                            >
                                <div className={classes.questionColorHolderColorBlock} style={{ backgroundColor: "#ff0000" }}></div>
                                <div className={classes.questionColorHolderColorBlock} style={{ backgroundColor: "#fffb00" }}></div>
                                <div className={classes.questionColorHolderColorBlock} style={{ backgroundColor: "#05ff00" }}></div>
                            </div>
                        </Card>
                    </Grid>
                </Grid>
                <div className={classes.sectionSpacer} />
                <h2 className={classes.sectionHeader}>Contest<LaptopMac className={classes.icon} /></h2>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Card className={classes.card}><CurrentContest /></Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Card className={classes.card}><UpdateContest /></Card>
                    </Grid>
                </Grid>
                <div className={classes.sectionSpacer} />
                <h2 className={classes.sectionHeader}>Team<People className={classes.icon} /></h2>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Card className={classes.card}><AccessCode /></Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Card className={classes.card}><ProfileDetails /></Card>
                    </Grid>
                    {(this.props.user.clearance_id > 1) &&
                        <Grid item xs={12}>
                            <Card className={classes.card}><TeamMembers /></Card>
                        </Grid>}
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    user: state.user,
    team: state.team,
    teamUsers: state.teamUsers
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(Profile)));
